import React from 'react';

import { cn } from 'src/component/ds/utils';

/* shadcn/ui's Skeleton: a pulsing block standing in for content that hasn't
 * loaded. Give it the size of whatever it replaces. */
function Skeleton ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot='skeleton'
      className={cn('ds-animate-pulse ds-rounded-ds ds-bg-accent', className)}
      {...props}
    />
  );
}

export { Skeleton };
